<template>
  <card>
    <list
      v-if="$store.state.user.sections['registry_templates']"
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :cardLink="cardLink"
      :isUpdate="true"
      :isAdd="true"
      :itemLink="itemLink"
      :setLink="setLink"
      :openItem="true"
      :fields="fields"
      :params="params"
      :searchDisable="true"
      @change="change"
      @changeFunction="changeFunction"
      v-model="val"
    />
  </card>
</template>
<script>
export default {
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      // $table->string('name'); //uzum
      //       $table->string('header_external'); //id
      //       $table->string('header_internal'); //UZUM id
      //       $table->string('code'); //uzum
      params: {},
      val: [],
      modalCreate: "registry_templates",
      fields: [
        {
          col: " col-12 col-md-12",
          key: "name",
          labelKey: "Название",
          label: "Название",
          type: "field",
          textType: "text",
        },
        {
          col: " col-12 col-md-12",
          key: "header_external",
          labelKey: "Название шапки EXCEL (внешний)",
          label: "Название шапки EXCEL (внешний)",
          type: "field",
          textType: "text",
        },
        {
          col: " col-12 col-md-12",
          key: "header_internal",
          labelKey: "Название шапки EXCEL (внутренний)",
          label: "Название шапки EXCEL (внутренний)",
          type: "field",
          textType: "text",
        },
        {
          col: " col-12 col-md-12",
          key: "code",
          labelKey: "Код",
          label: "Код",
          type: "field",
          textType: "text",
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_registry_template",
      itemLink: "registry_templates",
      setLink: "registry_templates",
      columns: [
        {
          key: "name",
          title: "Название",
        },
        {
          key: "header_external",
          title: "Название шапки EXCEL (внешний)",
        },
        {
          key: "header_internal",
          title: "Название шапки EXCEL (внутренний)",
        },
        {
          key: "code",
          title: "Код",
        },

        {
          detail: true,
          remove: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
